import React from 'react';
import clsx from 'clsx';

import { Button } from '@edx/components/button';
import { Title } from '@edx/components/typography';

import { BannerButtonProps } from './';

type Props = {
  className?: string;
  header: string;
  primaryButton: BannerButtonProps;
  secondaryButton?: BannerButtonProps;
};

export const SignupBanner: React.FC<Props> = ({ header, primaryButton, secondaryButton, className }) => (
  <section className={clsx('bg-white', className)}>
    <div className="flex flex-col max-w-6xl md:px-8 mx-auto pb-16 pt-32 px-4">
      <Title tag="h1" className="text-center text-gray-600 leading-tight">
        {header}
      </Title>

      <div className="flex space-x-2 justify-center mt-6">
        <Button href={primaryButton.link} textVariant="medium" size="xlarge">
          {primaryButton.text}
        </Button>
        {secondaryButton && (
          <Button href={secondaryButton.link} variant="outlineLight" textVariant="medium" size="xlarge">
            {secondaryButton.text}
          </Button>
        )}
      </div>
    </div>
  </section>
);
